export default __webpack_public_path__ + "static/media/dropDownIcon.c1c3c13a.svg";